import { render, staticRenderFns } from "./PopularProducts2.vue?vue&type=template&id=0b0a6076&"
import script from "./PopularProducts2.vue?vue&type=script&lang=js&"
export * from "./PopularProducts2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports